import { DownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useContext } from "react";
import moment from "moment";
import { staticText } from "../../utils/staticText";
import { TempWorkContext } from "../../contexts/tmpwork";
import { InitContext } from "../../contexts/init";

export const Count = () => {
  const { overview } = staticText;
  const { data, dispatch } = useContext(TempWorkContext);
  const { tmpWok, tmpWokList, openCount, workDate } = data;
  const { dispatch: InitDispatch } = useContext(InitContext);

  return (
    <div className="count-box">
      <h3
        className={`overview-title ${openCount && "open"}`}
        onClick={() => {
          dispatch({
            type: "setState",
            payload: {
              openCount: !openCount,
            },
          });
        }}
      >
        {overview.count.title}
        <DownOutlined className="arrow" />
      </h3>
      <div className={`count-list ${openCount && "open"}`}>
        {tmpWokList.map((ele) => {
          return (
            <div
              className={`count-item ${ele.id === tmpWok ? "selected" : ""}`}
              style={{ background: `${ele.sCol}` }}
              key={ele.id}
              onClick={() => {
                if (ele.id !== tmpWok) {
                  dispatch({
                    type: "setState",
                    payload: {
                      tmpWok: ele.id,
                      work: {
                        id: ele.id,
                        name: ele.name,
                      },
                      status: "showTask",
                      reload: true,
                    },
                  });
                  InitDispatch({
                    type: "setState",
                    payload: { dataLoading: { value: true, type: "search" } },
                  });
                }
              }}
            >
              <h5 className="count-work">{ele.name}</h5>
              <p className="count-num">{ele.num}</p>
              {moment(ele.cloDT).diff(moment(), "minutes") < ele.expMin && (
                <div className="alert">
                  <ExclamationCircleOutlined className="icon" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
